import { Dispatch, SetStateAction, useState } from "react";
import { Toaster } from "react-hot-toast";
import { IDataOptional, IDataPersonal, IPages } from "..";
import Button from "../../../components/Button";
import IconButton from "../../../components/IconButton";
import Input from "../../../components/Input";
import { toastError, toastWarn } from "../../../components/Toast";
import useAuthData from "../../../hook/useAppData";
import { IconLeftArrowVersion2 } from "../../../icons";
import { getCEP } from "../../../libs/getAddresByCep/getAddresByCep";
import { resCepApi } from "../../../libs/getAddresByCep/model";
import { remask, unRemask } from "../../../libs/remask-mask";

export const DataPersonal = ({
  setPage,
  dataPersonal,
  setDataPersonal,
  dataOptional,
  setDataOptional,
}: {
  setPage: Dispatch<SetStateAction<IPages>>;
  dataPersonal: IDataPersonal;
  setDataPersonal: Dispatch<SetStateAction<IDataPersonal>>;
  dataOptional: IDataOptional;
  setDataOptional: Dispatch<SetStateAction<IDataOptional>>;
}) => {
  const updateValues = (target: { name: string; value: any }) => {
    setDataPersonal({
      ...dataPersonal,
      [target.name]: target.value,
    });
  };
  const { token } = useAuthData();

  const back = () => setPage("Plans");

  const verefyDatasAndNext = () => {
    let quantityFieldsEmpty = 0;
    for (let field in dataPersonal) {
      if (!dataPersonal[field] && field !== "complement") quantityFieldsEmpty++;
    }
    if (quantityFieldsEmpty) return toastWarn("Preencha os campos para continuar");
    return setPage("VerefyData");
  };

  async function defineCEP(value: string) {
    const res: resCepApi = await getCEP(unRemask(value), token);
    if (res?.type === "service_error") {
      setDataPersonal({ ...dataPersonal });
      return toastError("CEP não encontrado");
    }
    const data = {
      postalCode: value,
      street: res?.street,
      district: res?.neighborhood,
      city: res?.city,
      state: res?.state,
    };
    setDataOptional({
      ...dataOptional,
      ...data,
    });
  }

  return (
    <>
      <Toaster />
      <div className="box-form gap-10" onKeyPressCapture={(e) => (e.code === "Enter" ? verefyDatasAndNext() : null)}>
        <div className="mb-12 mt-16 flex items-center w-full justify-center">
          <IconButton icon={IconLeftArrowVersion2} className="" onClick={back} />
          <span className="text-2rem">Adicione alguns dados do titular do cartão para prosseguir</span>
        </div>
        <div className="w-full h-full flex flex-col justify-around gap-12">
          <div className="box-row">
            <Input
              name="name"
              label={"Nome do Titular"}
              placeholder="Digite o nome do titular"
              value={dataPersonal?.name}
              setValue={(e: any) => {
                updateValues(e.target);
              }}
              autoFocus
            />
          </div>
          <div className="box-row">
            <Input
              name="email"
              label={"E-mail do Titular"}
              placeholder="Digite seu e-mail"
              value={dataPersonal?.email}
              setValue={(e) => updateValues(e.target)}
            />
            <Input
              name="phone"
              label="Telefone para contato (com DDD)"
              placeholder="Digite seu telefone"
              value={remask(dataPersonal?.phone, unRemask(dataPersonal?.phone)?.length > 10 ? ["(99) 99999-9999"] : ["(99) 9999-9999"])}
              setValue={(e) => updateValues(e.target)}
            />
          </div>
          <div className="box-row">
            <Input
              name="cpfCnpj"
              label={"CPF ou CNPJ do Titular"}
              placeholder="Digite um CPF ou CNPJ"
              value={remask(dataPersonal?.cpfCnpj, unRemask(dataPersonal?.cpfCnpj)?.length > 11 ? ["99.999.999/9999-99"] : ["999.999.999-99"])}
              setValue={(e) => updateValues(e.target)}
            />
            <Input
              name="postalCode"
              label={"CEP"}
              placeholder="Digite seu CEP"
              value={remask(dataPersonal?.postalCode, ["99.999-999"])}
              setValue={(e) => {
                updateValues(e.target);
                if (e.target.value?.length === 10) defineCEP(e.target.value);
              }}
            />
          </div>
          {dataPersonal?.postalCode?.length >= 10 ? (
            <>
              <div className="box-row">
                <Input
                  name="street"
                  label={"Logadouro"}
                  placeholder="Digite logadouro"
                  value={dataOptional?.street}
                  setValue={(e) => updateValues(e.target)}
                  disabled={true}
                />
                <Input
                  name="district"
                  label={"Bairro"}
                  placeholder="Digite o bairro"
                  value={dataOptional?.district}
                  setValue={(e) => updateValues(e.target)}
                  disabled={true}
                />
                <Input
                  name="addressNumber"
                  label={"Nº da residência"}
                  placeholder="Digite o Nº do endereço"
                  value={dataPersonal?.addressNumber}
                  setValue={(e) => updateValues(e.target)}
                />
              </div>
              <div className="box-row">
                <Input
                  name="complement"
                  label={"Complemento"}
                  placeholder="Digite o complemento (opcional)"
                  value={dataPersonal?.complement}
                  setValue={(e) => updateValues(e.target)}
                />
                <Input
                  name="city"
                  label={"Cidade"}
                  placeholder="Digite a cidade"
                  value={dataOptional?.city}
                  setValue={(e) => updateValues(e.target)}
                  disabled={true}
                />
                <Input
                  name="state"
                  label={"Estado"}
                  placeholder="Digite o estado"
                  value={dataOptional?.state}
                  setValue={(e) => updateValues(e.target)}
                  disabled={true}
                />
              </div>
            </>
          ) : (
            ""
          )}
        </div>
        <div className="flex w-full justify-end gap-8 mr-8 pb-5">
          <Button className="bg-blue-100 border-primary text-primary" onClick={back}>
            {" "}
            Cancelar{" "}
          </Button>
          <Button onClick={verefyDatasAndNext} className="bg-primary">
            {" "}
            Pronto{" "}
          </Button>
        </div>
      </div>
    </>
  );
};
